import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@mui/material/Tooltip';
import { orange } from '@mui/material/colors';
import {styled} from '@mui/system';


const StyledDocumentStats = styled('span')(({ theme }) =>({
    fontSize: theme.custom.font.medium,
    lineHeight: theme.custom.font.line_height
}));

const StyledYearRange = styled('span')(({ theme }) =>({
    color: theme.custom.color.grey
}));

const StyledLabelColumn = styled('td')({
    textAlign: 'right'
});

const StyledDataColumn = styled('td')({
    textAlign: 'right',
    width: 125
});

const StyledDocumentInfoRow = styled('tr')({
    lineHeight: 1
});

const StyledSpacer = styled('span')(({ theme }) =>({
    paddingLeft: 7,
    paddingRight: 10,
    color: theme.custom.color.grey
}));

const StyledUnverified = styled('span')({
    color: orange[500]
});


class DocumentStats extends React.Component {
    constructor(props) {
        super(props);
    }

    unverified_docs = (count, light) => {
        const label = light ? '' : 'unverified';
        if(count > 0){
            return (
                <span>
                    <StyledSpacer>|</StyledSpacer>
                    <Tooltip title={count + ' unverified'} placement="bottom-start">
                       <StyledUnverified>{count} {label}</StyledUnverified>
                    </Tooltip>
                </span>
            );
        }
    };

    render() {
        if (this.props.profile){
            const publication_year_range = this.props.profile.publication_min_year && this.props.profile.publication_max_year ? `(${this.props.profile.publication_min_year}-${this.props.profile.publication_max_year})`: '';
            const grant_year_range = this.props.profile.grant_min_year && this.props.profile.grant_max_year ? `(${this.props.profile.grant_min_year}-${this.props.profile.grant_max_year})`: '';
            if (this.props.showLabel) {
                return (
                    <table role="presentation">
                        <tbody>
                        <StyledDocumentInfoRow>
                            <StyledLabelColumn>Publications:</StyledLabelColumn>
                            <StyledDataColumn>{this.props.profile.publication_count} <StyledYearRange>{publication_year_range}</StyledYearRange></StyledDataColumn>
                            <td>{this.props.showVerified && this.unverified_docs(this.props.profile.unverified_publications_count)}</td>
                        </StyledDocumentInfoRow>
                        <StyledDocumentInfoRow>
                            <StyledLabelColumn>Grants:</StyledLabelColumn>
                            <StyledDataColumn>{this.props.profile.grant_count} <StyledYearRange>{grant_year_range}</StyledYearRange></StyledDataColumn>
                            <td>{this.props.showVerified && this.unverified_docs(this.props.profile.unverified_grants_count)}</td>
                        </StyledDocumentInfoRow>
                        </tbody>
                    </table>
                );
            }
            return (
                <StyledDocumentStats>
                    {this.props.profile.publication_count} <StyledYearRange>
                    {publication_year_range}</StyledYearRange> {this.props.showVerified && this.unverified_docs(this.props.profile.unverified_publications_count, true)}<br/>
                    {this.props.profile.grant_count} <StyledYearRange>
                    {grant_year_range}</StyledYearRange> {this.props.showVerified && this.unverified_docs(this.props.profile.unverified_grants_count, true)}
                </StyledDocumentStats>
            );
        }
        return <span></span>;
    }

}

DocumentStats.propTypes = {
    profile: PropTypes.object,
    showLabel: PropTypes.bool,
    showVerified: PropTypes.bool,
};

export default DocumentStats;
